import {
	Button,
	InputSelect,
	StylovyzeComposableDialog,
	useIsFeatureEnabled,
} from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGlobalization } from '@Translations';
import { addRouteNamespace } from '@Utils/actions';
import { NewIntegrationContainer } from '../IntegrationsTab.styles';
import { IntegrationTableFormValues } from '../types/integration.types';

interface NewIntegrationDialogProps {
	open: boolean;
	onCancel: () => void;
	setIntegrationOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setWhatIsVaparOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function NewIntegrationDialog({
	open,
	onCancel,
	setWhatIsVaparOpen,
	setIntegrationOpen,
}: NewIntegrationDialogProps) {
	const { t } = useGlobalization();
	const { values } = useFormikContext<IntegrationTableFormValues>();
	const history = useHistory();

	const vaparEnabled = useIsFeatureEnabled(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		'info-360-am-vapar',
	);
	const itPiptesEnabled = useIsFeatureEnabled(
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		'info-360-asset-itpipes',
	);

	const getMenuItems = () => {
		let items = [
			{
				key: 'arcgis',
				value: 'ArcGIS',
				label: t('ArcGIS Online'),
			},
		];
		if (itPiptesEnabled) {
			items = [
				...items,
				{
					key: 'itpipes',
					value: 'ITPipes',
					label: t('ITPipes'),
				},
			];
		}
		if (vaparEnabled) {
			items = [
				...items,
				{
					key: 'vapar',
					value: 'Vapar',
					label: t('VAPAR'),
				},
			];
		}
		return items;
	};

	return (
		<StylovyzeComposableDialog
			title={t('New Integration')}
			onCancel={onCancel}
			open={open}>
			<NewIntegrationContainer>
				<InputSelect
					menuItems={getMenuItems()}
					fieldAttrs={{ name: 'integrationType' }}
					selectProps={{ label: t('Integration Type') }}
					dataCy="integration-value-select"
				/>

				<Button
					dataCy="getStartedButton"
					color="primary"
					variant="contained"
					disabled={!values.integrationType}
					onClick={() => {
						if (values.integrationType == 'ArcGIS') {
							history.push(
								addRouteNamespace(
									'integrations/arcgis-settings',
								),
							);
						} else if (values.integrationType == 'ITPipes') {
							history.push(
								addRouteNamespace(
									'integrations/itpipes-settings',
								),
							);
						} else if (values.integrationType == 'Vapar') {
							setIntegrationOpen(false);
							setWhatIsVaparOpen(true);
						}
					}}>
					{t('Get Started')}
				</Button>
			</NewIntegrationContainer>
		</StylovyzeComposableDialog>
	);
}
